import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Linkedin, Instagram } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white footer-pattern" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center">
              <div className="bg-white rounded-lg p-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_gappro-qld/artifacts/pi084ay0_IMG_1430.jpeg" 
                  alt="Gap Pro - Caulking & Gap Sealing Specialists" 
                  className="h-16 w-auto"
                />
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed">
              Gold Coast's trusted commercial caulking specialists. From start to finish, 
              we deliver professional sealing solutions for commercial and residential projects.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-[#F59E0B] rounded-lg flex items-center justify-center transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-[#F59E0B] rounded-lg flex items-center justify-center transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-[#F59E0B] rounded-lg flex items-center justify-center transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Polyurethane Blockwork
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Render Expansion Joints
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Fire Rated Caulking
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Internal Silicone Works
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Bathroom & Kitchen Caulking
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Structural Control Joints
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Project Gallery
                </Link>
              </li>
              <li>
                <Link to="/quote" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Get a Quote
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                <span className="text-slate-400">
                  Gold Coast, Queensland<br />
                  Australia
                </span>
              </li>
              <li>
                <a href="tel:+61435825379" className="flex items-center gap-3 text-slate-400 hover:text-[#F59E0B] transition-colors">
                  <Phone className="w-5 h-5 text-[#F59E0B] flex-shrink-0" />
                  <span>0435 825 379</span>
                </a>
              </li>
              <li>
                <a href="mailto:danny@gappro.com.au" className="flex items-center gap-3 text-slate-400 hover:text-[#F59E0B] transition-colors">
                  <Mail className="w-5 h-5 text-[#F59E0B] flex-shrink-0" />
                  <span>danny@gappro.com.au</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                <span className="text-slate-400">
                  Mon - Fri: 6:30am - 5:00pm
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm text-center md:text-left">
            &copy; {currentYear} Gap Pro Pty Ltd. All rights reserved. ABN: 12 345 678 901
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-400 hover:text-[#F59E0B] transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
